import { render, staticRenderFns } from "./admin-layout.component.vue?vue&type=template&id=d340a1a8"
import script from "./admin-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports